import { IHomePoster } from "@interfaces";
import axiosClient from "./axiosClient";

export const homePosterApi = {
    getList: () => {
        const url = "/posters";
        return axiosClient.get(url);
    },
    addData: (values: IHomePoster) => {
        const url = "/posters";
        return axiosClient.post(url, values);
    },
    editData: (values: IHomePoster, idItem: string) => {
        const url = `/posters/${idItem}`;
        return axiosClient.put(url, values);
    },
    getItem: (idItem: string) => {
        const url = `/posters/${idItem}`;
        return axiosClient.get(url);
    },
    deleteItem: (idItem:string) => {
        const url = `/posters/${idItem}`;
        return axiosClient.delete(url);
    }, 
    uploadImage: (values:FormData) => {
         const url = "/upload";
        return axiosClient.post(url, values);
    }
};
